export enum LoginText {
  TITLE = 'Sign in to Work',
  EMAIL = 'Email',
  PASSWORD = 'Password',
  SIGN_IN = 'Sing in',
}
